import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IDesignationList } from '../../../Pages/UserDesignation/IDesignation';

export const AddDesignationSlicer = createSlice({
  name: 'AddDesignation',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IDesignationList>,
  reducers: {
    addDesignation: (state, _) => {
      state.isLoading = true;
    },
    successAddDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddDesignationState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addDesignation,
  failureAddDesignation,
  successAddDesignation,
  clearAddDesignationState,
} = AddDesignationSlicer.actions;

export default AddDesignationSlicer.reducer;
